import React from "react";
import CompanySelector from "../common/CompanySelector";

export default function DashboardHeader({
  companyList,
  selectedCompany,
  onChange,
}) {
  return (
    <div className="flex justify-between items-center mt-[30px] mb-6">
      <h1 className="text-[24px] font-medium text-[#505050]">Dashboard</h1>
      <CompanySelector
        companyList={companyList}
        selectedCompany={selectedCompany}
        onCompanyChange={onChange}
        selectClassName="!p-0 !pl-2 !pr-2 text-[0.9rem] w-[140px]"
      />
    </div>
  );
}
